import { z } from 'zod';
import { TicketStatusFilterSchema } from '@/features/stacktrace/tickets/-constants';
import { TicketTableColumns } from './-table/type';

/**
 * プロダクション詳細 > 開発スコープタブ の URL search スキーマ。
 *
 * development-tickets 台帳の URL search を参考にした構成。
 * `targetProductionId` は URL ではなく親 lazy route が `useParams` から取得して
 * 固定値で注入するため、ここでは管理しない。
 *
 * - status:        ステータスタブ用フィルタ（"ALL" + 6 ドメイン値）
 * - freeText:      検索バー（title / code 部分一致）
 * - pageIndex:     0-origin ページ番号
 * - pageSize:      1 ページあたりの件数
 * - sortColumn:    ソート対象カラム
 * - orderDirection ソート方向
 */
export const DevScopeTicketListFilterSchema = z.object({
  status: TicketStatusFilterSchema.default('ALL'),
  freeText: z.string().optional(),
  pageIndex: z.coerce.number().min(0).default(0),
  pageSize: z.coerce.number().min(1).max(1000).default(100),
  sortColumn: z.nativeEnum(TicketTableColumns).optional(),
  orderDirection: z.enum(['asc', 'desc']).default('desc')
});